import styled from '@emotion/styled';
import { CharacterCard } from '~/components/CreateNewCharacter/SelectCharacter/CharacterList/CharacterList';

export default function RoundProfile() {
  return <Container />;
}

const Container = styled(CharacterCard)`
  border: 1px solid transparent;
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
`;
